import { Navigate } from "react-router-dom";
import { useAdminAuthStore } from "@/stores/adminAuthStore";

export function AdminGuestOnly({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAdminAuthStore((s) => s.isAuthenticated);
  const isLoading = useAdminAuthStore((s) => s.isLoading);

  if (isLoading) return null; // wait for session restore before deciding

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
